import * as React from 'react'

import { ComponentWithSubheader } from 'dash/shared'
import { MeEdit } from './edit'

export default class User {
  // static Create = UserCreate;
  static Edit = () => {
    return <ComponentWithSubheader path={['My Account']} label={'Preferences'} component={MeEdit} />
  }
}
